import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

export const PasswordInput = ({ className = "", "data-testid": testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Input {...props} type={show ? "text" : "password"} data-testid={testId} className={`${className} pr-10`} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
        aria-label={show ? "Nascondi password" : "Mostra password"} title={show ? "Nascondi password" : "Mostra password"}
        data-testid={`${testId}-toggle`}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </>
  );
};
